export var requiredOptions = [
    'isRTL',
    'cubeType',
    'cubeImages',
    'arrowsSize',
    'arrowsPosition',
    'cubeRatio',
    'cropRatio',
    'layoutParams_cropRatio',
    'collageAmount',
    'collageDensity',
    'columnsWidth',
    'cropOnlyFill',
    'chooseBestGroup',
    'externalInfoHeight',
    'externalInfoWidth',
    'fixedColumns',
    'groupsPerStrip',
    'galleryMargin',
    'layoutParams_gallerySpacing',
    'groupTypes',
    'groupSize',
    'isVertical',
    'imageMargin',
    'minItemSize',
    'scrollDirection',
    'placeGroupsLtr',
    'rotatingGroupTypes',
    'layoutParams_repeatingGroupTypes',
    'rotatingCropRatios',
    'smartCrop',
    'scatter',
    'smartCrop',
    'targetItemSize',
    'hasThumbnails',
    'thumbnailSize',
    'thumbnailSpacings',
    'galleryThumbnailsAlignment',
    'isSlideshow',
    'galleryLayout',
    'slideshowInfoSize',
    'layoutParams_structure_galleryRatio_value',
    'gallerySizeType',
    'gallerySizePx',
    'gallerySize',
    'enableInfiniteScroll',
    'imageInfoType',
    'textsHorizontalPadding',
    'gridStyle',
    'numberOfImagesPerRow',
    'calculateTextBoxHeightMode',
    'textBoxHeight',
    'textsVerticalPadding',
    'titlePlacement',
    'textBoxWidthPercent',
    'calculateTextBoxWidthMode',
];
//# sourceMappingURL=v4layoutRelevantOptions.js.map